import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { homeFor } from "../../redux/features/authSlice";
import "./Landing.css";

// hortihub.in - the public front door. What it is, who it is for, what it
// does today, and two ways in: sign in, or ask for access.

export const PublicNav = () => {
  const { isAuthenticated, user } = useSelector((s) => s.auth);
  return (
    <nav className="hh-nav">
      <Link to="/" className="hh-brand">HortiHub<small>by ManBhawan Nursery</small></Link>
      <div className="d-flex gap-2">
        {isAuthenticated ? (
          <Link to={homeFor(user)} className="btn btn-success btn-sm">Open portal</Link>
        ) : (
          <>
            <Link to="/request-access" className="btn btn-outline-success btn-sm d-none d-sm-inline-block">Request access</Link>
            <Link to="/login" className="btn btn-success btn-sm">Sign in</Link>
          </>
        )}
      </div>
    </nav>
  );
};

export const PublicFooter = () => (
  <footer className="hh-footer">
    <div className="inner">
      <div>© {new Date().getFullYear()} ManBhawan Eco Ventures LLP · Noida &amp; Ghaziabad · GSTIN 09AAYFP3567B1ZR</div>
      <div><a href="https://manbhawannursery.in" target="_blank" rel="noreferrer">manbhawannursery.in</a> · <a href="tel:+919205556651">+91 92055 56651</a></div>
    </div>
  </footer>
);

const Landing = () => (
  <div className="hh">
    <PublicNav />
    <header className="hh-hero">
      <div className="inner">
        <h1>Plants, inputs and gardening services for your society — all in one place.</h1>
        <p className="lead">
          HortiHub is ManBhawan Nursery's portal for societies, schools, malls and corporate campuses. Send your plant
          requirement from your phone, get a GST quotation, approve it, and track delivery — without a single WhatsApp
          thread getting lost.
        </p>
        <div className="cta">
          <Link to="/request-access" className="btn btn-success">Request access</Link>
          <Link to="/login" className="btn btn-outline-success">Sign in</Link>
        </div>
        <div className="for">For residential societies · schools &amp; colleges · malls · corporate offices · hospitals · facility-management companies</div>
      </div>
    </header>

    <section className="hh-section">
      <h2>How it works</h2>
      <div className="hh-steps">
        <div className="hh-step"><span className="n">1</span><h3>Send the requirement</h3><p>Type it, or attach a photo of the gardener's list, a PDF or an Excel sheet. Sizes and quantities as you have them.</p></div>
        <div className="hh-step"><span className="n">2</span><h3>Get a quotation</h3><p>Every item priced with HSN and GST, valid for 15 days, as a PDF your accounts team can file.</p></div>
        <div className="hh-step"><span className="n">3</span><h3>Approve on your phone</h3><p>Approve, ask for a revision, or reject. Upload your purchase order if your society needs one.</p></div>
        <div className="hh-step"><span className="n">4</span><h3>Track the delivery</h3><p>See each dispatch, vehicle and challan as it leaves the nursery, and confirm receipt at the gate.</p></div>
      </div>
    </section>

    <div className="hh-band">
      <div className="hh-section">
        <h2>Gardening AMC, service requests and visit reports — coming next.</h2>
        <Link to="/request-access" className="btn">Talk to us</Link>
      </div>
    </div>

    <section className="hh-section">
      <h2>Why ManBhawan</h2>
      <div className="hh-facts">
        <div className="hh-fact"><div className="big">Delhi NCR</div><div className="lbl">Growing and supplying plants to societies, offices and institutions across NCR</div></div>
        <div className="hh-fact"><div className="big">300+</div><div className="lbl">Plant varieties in bulk, from our own and partner nurseries</div></div>
        <div className="hh-fact"><div className="big">3 nurseries</div><div className="lbl">Noida, Pusta Road and Vasundhara</div></div>
        <div className="hh-fact"><div className="big">GST invoiced</div><div className="lbl">ManBhawan Eco Ventures LLP — proper paperwork for your society's books</div></div>
      </div>
    </section>

    <PublicFooter />
  </div>
);

export default Landing;
